import { makeStyles } from '@mui/styles';
import CircularProgress from 'apollo-react/components/CircularProgress';
import IconButton from 'apollo-react/components/IconButton';
import Tooltip from 'apollo-react/components/Tooltip';
import Download from 'apollo-react-icons/Download';
import Trash from 'apollo-react-icons/Trash';
import React from 'react';

import { ReactComponent as DBIcon } from '../../assets/icons/database.svg';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { DOWNLOAD_ICON_ACTIONS_TYPES } from '../../form-designer/constants/runtime.constants';
import { getUITA } from '../../utils/commonUtils';

const useStyles = makeStyles(({ palette }) => ({
  container: {
    display: 'inline-block',
    marginLeft: '5px',
  },
  databaseIcon: {
    fill: palette?.grey[700],
    width: 20,
    height: 20,
    marginTop: '6px',
  },
}));

export const DownloadButton = ({ actionType, onClick }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  switch (actionType) {
    case DOWNLOAD_ICON_ACTIONS_TYPES.DELETE:
      return (
        <Tooltip title={translateString('Delete local copy')}>
          <IconButton
            aria-label={translateString('Delete local copy')}
            size="small"
            color="default"
            onClick={() => onClick(DOWNLOAD_ICON_ACTIONS_TYPES.DELETE)}
          >
            <Trash />
          </IconButton>
        </Tooltip>
      );

    case DOWNLOAD_ICON_ACTIONS_TYPES.DOWNLOAD:
      return (
        <Tooltip title={translateString('Save for offline')}>
          <IconButton
            aria-label={translateString('Save for offline')}
            size="small"
            color="default"
            onClick={() => onClick(DOWNLOAD_ICON_ACTIONS_TYPES.DOWNLOAD)}
          >
            <Download />
          </IconButton>
        </Tooltip>
      );

    case DOWNLOAD_ICON_ACTIONS_TYPES.DOWNLOADING:
      return (
        <div className={classes.container}>
          <CircularProgress style={{ display: 'block' }} size="20px" variant="indeterminate" />
        </div>
      );

    case DOWNLOAD_ICON_ACTIONS_TYPES.DOWNLOADED:
      return (
        <Tooltip title={translateString('Copied in local storage for offline access')}>
          <div ui-ta={getUITA('db-icon')} className={classes.container}>
            <DBIcon className={classes.databaseIcon} title="" />
          </div>
        </Tooltip>
      );
    default:
      return null;
  }
};
